import { ClientClaimTypeEnum } from "./claim-data-enums";

// Explicit sets for tooltip logic
export const LIFE_PLAN_CODES = new Set([
  '01201', '01209', '01202', '01210', '01203', '01211', '01204', '01235', '01237',
  '01205', '01212', '01206', '01213', '01207', '01214', '01208', '01226'
]);

export const NON_LIFE_PLAN_CODES = new Set([
  '01215', '01223', '01217', '01227', '01290', '01245', '01244', '01238',
  '01240', '01288', '01241'
]);

// Disability coverage codes for Claims Report page
export const DISABILITY_PLAN_CODES = new Set([
  '01215', '01217', '01223', '01229', '01233'
]);

// Disability codes that support payment reports
export const DISABILITY_PAYMENT_PLAN_CODES = new Set([
  '01215', '01217', '01229', '01233', '01223'
]);

// ASO STD with Full Service - for integrated benefit determination report
export const ASO_STD_FULL_SERVICE_PLAN_CODES = new Set([
  '01223'
]);


// TODO: Verify the constants below with business team.
// The internal arrays (PlanCodesLife, PlanCodesADD) in plan-code-mapping might be incomplete
const PlanCodesADD = [
    "01209",
    "01210",
    "01211",
    "01235",
    "012367"
  ];

const PlanCodesLife = [
    "01201",
    "01202",
    "01203",
    "01204",
    "01205",
    "01206",
    "01207",
    "01208"
  ];

const PlanCodesLTD = [
    "01217"
  ];

const PlanCodesSTD = [
    "01215",
    "01223"
  ];

const planCodeToClaimTypeMapping = (planCode: string): ClientClaimTypeEnum => {
    if (PlanCodesADD.includes(planCode)) {
        return ClientClaimTypeEnum.AccidentalDeathAndDismemberment;
    } else if (PlanCodesLife.includes(planCode)) {
        return ClientClaimTypeEnum.Life;
    } else if (PlanCodesLTD.includes(planCode)) {
        return ClientClaimTypeEnum.LongTermDisability;
    } else if (PlanCodesSTD.includes(planCode)) {
        return ClientClaimTypeEnum.ShortTermDisability;
    }

    return ClientClaimTypeEnum.Unknown
}

export const planCodesToClaimTypeMapping = (planCodes: Set<string>): ClientClaimTypeEnum[] => {
    const claimTypes: ClientClaimTypeEnum[] = [];

    planCodes.forEach(planCode => {
        const claimType = planCodeToClaimTypeMapping(planCode);
        if (claimType !== ClientClaimTypeEnum.Unknown && !claimTypes.includes(claimType)) {
            claimTypes.push(claimType);
        }
    });

    const claimTypesSorted = claimTypes.sort((a, b) => a.localeCompare(b));

    return claimTypesSorted;
}
